import api from "./apiHelper";
import { queryCache } from "react-query";
import { useCustomPaginatedQuery, useCustomQuery } from "hooks/reactQuery";

export const postRegisterLead = (userId, payload) => {
  return api.post(`/leads/${userId}/register`, payload);
};

export const getLeadDetails = (leadId) => {
  return api.get(`/leads/${leadId}`);
};

export const deleteLead = async (leadId) => {
  await api.delete(`/leads/${leadId}`);
  return queryCache.refetchQueries("leads");
};

export const useGetLeads = (query, onError) => {
  const getLeads = (key, query) => {
    return api.get(`/leads/aggregation`, {
      params: { ...query },
    });
  };
  return useCustomPaginatedQuery("leads", getLeads, query, {
    onError,
  });
};

export const patchPic = (
  data = {
    leadId: String,
    PICId: String,
  }
) => {
  return api.post(`/leads/re-assign-lead-pic`, data);
};

// export const useGetPoliciesForSuggestions = (name, onError) => {
//   const getPolicies = async (key, name) => {
//     return api.get(`/policy/name/${name}`);
//   };
//   return useCustomQuery("policiesForSuggestions", [name], getPolicies, {
//     onError,
//     shouldFetch: !!name
//   });
// };

// export const useGetPolicies = (query, onError) => {
//   const getPolicies = async (key, query) => {
//     return api.get(`/policy/aggregation`, {
//       params: { ...query }
//     });
//   };
//   return useCustomPaginatedQuery("policies", getPolicies, query, {
//     onError
//   });
// };

// export const useGetPolicyDetails = (policyId, query, onError) => {
//   const getPolicyDetails = async (key, policyId, query) => {
//     return api.get(`/policy/${policyId}`, {
//       params: { ...query }
//     });
//   };
//   return useCustomQuery("policyDetails", [policyId, query], getPolicyDetails, {
//     onError,
//     shouldFetch: !!policyId
//   });
// };

// export const patchPolicy = (policyId, payload) => {
//   return api.patch(`/policy/${policyId}`, payload);
// };
